<template>
  <v-dialog :value="active" :lazy="true" persistent max-width="800px">
    <v-card>
      <v-form ref="addForm" @submit.prevent="add()">
        <v-toolbar tabs card color="primary" dark>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{$t('instructions.addTitle')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  :label="$t('instructions.name')"
                  v-model="currentModel.name"
                  :rules="[v => !!v || $t('fields.required')]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="instructionsLoading"
            type="submit"
            flat
          >{{$t('general.add')}}</v-btn>
          <v-btn
            color="secondary"
            :disabled="instructionsLoading"
            flat
            @click.native="$emit('closedialog')"
          >{{$t('general.close')}}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {

  name: "InstructionAdd",

  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentModel: {}
    };
  },

  methods: {

    async init() {
      this.currentModel = Object.assign({}, this.instructionModel)
      await this.$nextTick();
      this.$refs.addForm.reset();
    },

    async add() {
      if (this.$refs.addForm.validate()) {
        if (
          await this.addInstruction(this.currentModel)
        ) {
          this.$emit("closedialog");
        }
      }
    },

    ...mapActions('instructions', {
      addInstruction: 'add'
    })

  },
  computed: {
    ...mapGetters('instructions', {
      instructionsLoading: 'loading',
      instructionModel: 'model'
    })
  },

  watch: {
    active(val) {
      if (val) {
        this.init();
      }
    }
  }
};
</script>
<style>
</style>

